/**
 * Device Detection Utility
 * Detects device type based on user agent and screen size
 */

export type DeviceType = 'mobile' | 'tablet' | 'desktop';

/**
 * Detect device type based on user agent and screen size
 * @returns Device type: 'mobile', 'tablet', or 'desktop'
 */
export function detectDeviceType(): DeviceType {
  if (typeof navigator === 'undefined' || typeof window === 'undefined') {
    return 'desktop';
  }

  const userAgent = navigator.userAgent.toLowerCase();
  const width = window.innerWidth;

  const isMobile =
    /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(userAgent) ||
    (width < 768 && /mobile/i.test(userAgent));

  const isTablet =
    /ipad|android(?!.*mobile)|tablet|kindle|silk|playbook/i.test(userAgent) ||
    (width >= 768 && width < 1024 && /touch/i.test(userAgent));

  if (isMobile) {
    return 'mobile';
  } else if (isTablet) {
    return 'tablet';
  } else {
    return 'desktop';
  }
}
